import { render, staticRenderFns } from "./SubGroupMenu.vue?vue&type=template&id=10fdc00c&scoped=true&"
import script from "./SubGroupMenu.vue?vue&type=script&lang=js&"
export * from "./SubGroupMenu.vue?vue&type=script&lang=js&"
import style0 from "./SubGroupMenu.vue?vue&type=style&index=0&id=10fdc00c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10fdc00c",
  null
  
)

export default component.exports